import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQueryClient } from "@tanstack/react-query";

export const useDeleteAttachment = () => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();   

    const deleteAttachment = async (id: string) => {
        try {
            await axios.delete(`/api/attachments/${id}`);
            queryClient.invalidateQueries({queryKey: ["questions"]})
            return;
        } catch (error) {
            throw new Error(t("errors.attachmentDelete"));
        }
    }

    return {
        deleteAttachment
    }
}